export const PIE_CHART_CONTAINER_WIDTH = 188;
export const PIE_CHART_CONTAINER_HEIGHT = 188;

export const PIE_CHART_COLOR_MAP: Record<string, string> = {
  hot: "#FC8181",
  warm: "#FBD38D",
  cold: "#90CDF4",
  unknown: "#CBD5E0",
};
